<template>
  <div><slot name="activator" /></div>
</template>
